/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Summary_HintInputs */

const cs_deal_payments_summary_hint = /** @type {(inputs: Deal_Payments_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stavy jednotlivých řádků jsou nezávislé. Nejde o platební bránu — jen CRM kniha.`)
};

const en_deal_payments_summary_hint = /** @type {(inputs: Deal_Payments_Summary_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line statuses are independent. CRM ledger only — not a payment gateway.`)
};

/**
* | output |
* | --- |
* | "Line statuses are independent. CRM ledger only — not a payment gateway." |
*
* @param {Deal_Payments_Summary_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_summary_hint = /** @type {((inputs?: Deal_Payments_Summary_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Summary_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_summary_hint(inputs)
	return cs_deal_payments_summary_hint(inputs)
});